import store from '@/vue-instance/store';

export const campGuestMiddleware = (to, from, next) => {
  if (store.getters['camp/auth/isLoggedIn'] && !store.getters['camp/auth/isTokenExpired']) {
    next({ name: 'camp.dashboard', params: { language: store.getters['localization/getLanguage'] } });
  }
};
